import { Injectable } from "@angular/core";
import { Adapter } from "./adapter";

export class ISGProvider {

    constructor(
        public id: number,
        public ZipCode: number,
        public Provider: string,
        public Technology: string,
        public MaxSpeed: number,
        public City: number,
        public Campaign: string,
        public Url: string,
        public Phone: string
     ) {}
}

// @Injectable({
//   providedIn: "root"
// })
// export class ISGAdapter implements Adapter<ISGProvider> {
//   adapt(item: any): ISGProvider {
//       return new ISGProvider(item.id, item.ZipCode, item.Provider, item.Technolgy, item.MaxSpeed, item.City, item.Campaign, item.Url, item.Phone)
//   }
// }

export class ISGObject {

    constructor(
        public dslCable: ISGProvider,
        public fiber: ISGProvider,
        public satellite: ISGProvider
     ) {}
}

@Injectable({
  providedIn: "root"
})
export class ISGProviderAdapter implements Adapter<ISGObject> {
  adapt(item: any): ISGObject {
      var dslCable = item.dslCable
      var fiber = item.fiber
      var satellite = item.satellite
      return new ISGObject(
        new ISGProvider(dslCable.id, dslCable.ZipCode, dslCable.Provider, dslCable.Technolgy, dslCable.MaxSpeed, dslCable.City, dslCable.Campaign, dslCable.Url, dslCable.Phone),
        new ISGProvider(fiber.id, fiber.ZipCode, fiber.Provider, fiber.Technolgy, fiber.MaxSpeed, fiber.City, fiber.Campaign, fiber.Url, fiber.Phone),
        new ISGProvider(satellite.id, satellite.ZipCode, satellite.Provider, satellite.Technolgy, satellite.MaxSpeed, satellite.City, satellite.Campaign, satellite.Url, satellite.Phone)
      )
  }
}